import React, { useState, useEffect } from "react";
import { db } from "@/api/db";
import { motion, AnimatePresence } from "framer-motion";
import StepBriefing from "../components/interview/StepBriefing";
import StepConfig from "../components/interview/StepConfig";
import InterviewSession from "../components/interview/InterviewSession";
import InterviewAnalysis from "../components/interview/InterviewAnalysis";

const PROGRESS_STEPS = ["briefing", "config", "session"];

export default function InterviewSimulator() {
  const [user, setUser] = useState(null);
  const [step, setStep] = useState("briefing");
  const [sessionData, setSessionData] = useState({});
  const [session, setSession] = useState(null);

  useEffect(() => {
    db.auth.me().then(setUser).catch(() => {});
  }, []);

  function handleBriefing(data) {
    setSessionData(d => ({ ...d, ...data }));
    setStep("config");
  }

  async function handleConfig(data) {
    try {
      // camera_granted is local-only — not a DB column
      const { camera_granted: _cg, ...configData } = data;
      const merged = { ...sessionData, ...configData };
      const created = await db.entities.InterviewSession.create({
        ...merged,
        user_email: user.email,
        status: "in_progress",
        transcript: [],
      });
      setSession(created);
      setStep("session");
    } catch (err) {
      console.error("Erro ao criar sessão:", err);
      alert("Erro ao iniciar a entrevista. Verifique o console.");
    }
  }

  async function handleSessionFinish(transcript, duration, frames) {
    setSession(s => ({ ...s, transcript, duration_seconds: duration, status: "analyzing", video_frames: frames || [] }));
    setStep("analysis");
  }

  function handleRestart() {
    setSession(null);
    setSessionData({});
    setStep("briefing");
  }

  const stepIndex = PROGRESS_STEPS.indexOf(step);

  return (
    <div className="max-w-5xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-1">
          <h1 className="text-2xl font-bold" style={{ fontFamily: "Poppins, sans-serif", color: "#003326" }}>
            Simulador de Entrevista Real
          </h1>
          <span className="text-xs px-2 py-0.5 rounded-full font-semibold" style={{ background: "#E5FF52", color: "#003326" }}>
            IA
          </span>
          <span className="text-xs px-2 py-0.5 rounded-full font-semibold" style={{ background: "#FEEDB4", color: "#65541B" }}>
            Beta
          </span>
        </div>
        <p className="text-sm" style={{ color: "#646C6F" }}>Treine como se fosse a vaga dos seus sonhos.</p>

        {step !== "analysis" && (
          <div className="mt-4 flex gap-1.5">
            {PROGRESS_STEPS.map((s, i) => (
              <div key={s} className="flex-1 h-1.5 rounded-full transition-all"
                style={{ background: i <= stepIndex ? "#00DCA4" : "#E5E9EA" }} />
            ))}
          </div>
        )}
      </div>

      <AnimatePresence mode="wait">
        <motion.div key={step} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.2 }}>
          {step === "briefing" && <StepBriefing onNext={handleBriefing} />}
          {step === "config"   && <StepConfig onNext={handleConfig} onBack={() => setStep("briefing")} />}
          {step === "session"  && session && <InterviewSession session={session} onFinish={handleSessionFinish} />}
          {step === "analysis" && session && <InterviewAnalysis session={session} onRestart={handleRestart} />}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
